export default __webpack_public_path__ + "static/media/jalgaonqr.fda87c58.png";